module.exports = __webpack_public_path__ + "static/media/fiets.a2efedd3.png";